
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ApiDocumentation = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>API Documentation</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h4 className="font-semibold mb-2">Endpoint</h4>
          <code className="text-sm bg-muted px-2 py-1 rounded block">
            POST https://nkrxgmguwqkczuphqcvu.supabase.co/functions/v1/submit-terrace-api
          </code>
        </div>
        
        <div>
          <h4 className="font-semibold mb-2">Headers</h4>
          <pre className="text-sm bg-muted p-3 rounded">
{`Content-Type: application/json
x-api-key: your_api_key_here`}
          </pre>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Request Body</h4>
          <pre className="text-sm bg-muted p-3 rounded">
{`{
  "mapsUrl": "https://maps.app.goo.gl/...",
  "submitterName": "Your Name (optional)",
  "submitterEmail": "your@email.com (optional)"
}`}
          </pre>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Response</h4>
          <pre className="text-sm bg-muted p-3 rounded">
{`{
  "success": true,
  "submissionId": "uuid",
  "status": "approved|pending",
  "confidenceScore": 0.85,
  "autoApproved": true,
  "message": "Terrace automatically approved and published",
  "terrace": {
    "name": "Cafe Name",
    "address": "Street Address",
    "type": "cafe"
  }
}`}
          </pre>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApiDocumentation;
